import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChildCompComponent, UtilExampleForm } from '@r1-compass-library/utilities';
import { FormArray, FormGroup, NonNullableFormBuilder, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { BehaviorSubject } from 'rxjs';

@Component({
    selector: 'r1-compass-app-test',
    templateUrl: './test.component.html',
    styleUrl: './test.component.scss',
    imports: [CommonModule, ChildCompComponent, MatInputModule, MatFormFieldModule, ReactiveFormsModule],
})
export class TestComponent {
    readonly #fb = inject(NonNullableFormBuilder);
    private rxjsForm = new BehaviorSubject<FormArray<FormGroup<UtilExampleForm>>>(
        this.#fb.array([
            this.#fb.group({
                type: this.#fb.control<string | null>(null),
                id: this.#fb.control<number | null>(-1),
            }),
            this.#fb.group({
                type: this.#fb.control<string | null>('b'),
                id: this.#fb.control<number | null>(-1),
            }),
        ])
    );

    rxjsForm$ = this.rxjsForm.asObservable();
    testForm$ = this.rxjsForm$;
}
